module.exports = __webpack_public_path__ + "static/media/logo-black.332e7a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/assets/img/logo-black.png
// module id = ./src/statsradio/assets/img/logo-black.png
// module chunks = 18